import SecurityCompliance from "../home/securityCompliance/SecurityCompliance"
import WhyUsDeliveryPath from "./whyUsDeliveryPath/WhyUsDeliveryPath"
import WhyUsHero from "./whyUsHero/WhyUsHero"
import WhyUsTrustMatrix from "./whyUsTrustMatrix/WhyUsTrustMatrix"

const WhyUs = () => {
  return (
    <>
    <WhyUsHero />
    <WhyUsTrustMatrix />
    <WhyUsDeliveryPath />
    <SecurityCompliance />
    </>
  )
}

export default WhyUs